// ReusableTooltip.js
import * as React from "react";
import MUITooltip from "@mui/material/Tooltip";

import SC from "./style";
import theme from "@theme";

const Tooltip = ({
  title,
  placement,
  children,
  backgroundcolor = theme.colors.themeColor,
  textColor = "#fff",
  zIndex = 9000,
}) => {
  return (
    <>
      <SC.GlobalStyles
        backgroundcolor={backgroundcolor}
        textColor={textColor}
        zIndex={zIndex}
      />
      <MUITooltip title={title} placement={placement}>
        {children}
      </MUITooltip>
    </>
  );
};

export default Tooltip;
